import { memo } from 'react';
import DotTooltip from './DotTooltip.js';
import { useSeekableStart } from './ProgressBarContext.js';
import { ProgressBarClassNames, COLOR_BLUE } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/slider';
import '@dtvgo/tooltip';
import '@dtvgo/classnames';

/* External */
function SeekableStartDot(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$arrowPlacement = _ref.arrowPlacement,
    arrowPlacement = _ref$arrowPlacement === void 0 ? 'center' : _ref$arrowPlacement,
    _ref$tooltipBgColor = _ref.tooltipBgColor,
    tooltipBgColor = _ref$tooltipBgColor === void 0 ? COLOR_BLUE : _ref$tooltipBgColor,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsx(DotTooltip, {
    className: ProgressBarClassNames.element('seekable-start-dot', className),
    value: useSeekableStart(),
    placement: placement,
    tooltipBgColor: tooltipBgColor,
    arrowPlacement: arrowPlacement,
    children: children
  });
}
var SeekableStartDot$1 = /*#__PURE__*/memo(SeekableStartDot);

export { SeekableStartDot$1 as default };
//# sourceMappingURL=SeekableStartDot.js.map
